module.exports = __webpack_public_path__ + "a95d042803a0c725fcaa388abe010990.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/baikalsea.png
// module id = 400
// module chunks = 0